import find from 'lodash/fp/find';
import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';
import some from 'lodash/fp/some';

import { createSelector } from 'reselect';

import removeAppendedVersion from 'utils/removeAppendedVersion';

import initialState from './initialState';

const selectGiftWithPurchaseState = getOr(initialState, 'giftWithPurchase');

export const getGiftWithPurchaseListLoading = createSelector(
  selectGiftWithPurchaseState,
  get('isLoading')
);

export const getGiftWithPurchaseError = createSelector(selectGiftWithPurchaseState, get('error'));

export const getGiftWithPurchaseList = createSelector(
  selectGiftWithPurchaseState,
  getOr([], 'list')
);

export const getIsGiftWithPurchaseListLoaded = createSelector(
  getGiftWithPurchaseList,
  list => list !== initialState.list
);

export const getFirstActiveGiftWithPurchaseBannerData = createSelector(
  getGiftWithPurchaseList,
  list => find({ should_show_banner: true }, list)
);

export const getIsGiftWithPurchaseBannerActive = createSelector(
  getFirstActiveGiftWithPurchaseBannerData,
  firstActiveGiftWithPurchase => Boolean(firstActiveGiftWithPurchase)
);

export const getIsGiftWithPurchaseActive = createSelector(
  [getGiftWithPurchaseList, (_state, offeredVariantType) => offeredVariantType],
  (list, offered_variant_type) => some({ offered_variant_type }, list)
);

export const getGiftWithPurchaseByOfferedVariantType = createSelector(
  [getGiftWithPurchaseList, (_state, offeredVariantType) => offeredVariantType],
  (list, offeredVariantType) => {
    return find(
      li =>
        removeAppendedVersion(offeredVariantType) ===
        removeAppendedVersion(li?.offered_variant_type)
    )(list);
  }
);
